import {css} from 'lit'; export default css`sds-textarea [data-left-aligned]{margin-inline-end:auto}`;
    